import styled from '@emotion/styled'
import Card from '@material-ui/core/Card'

export const CommonCard = styled(Card)`
  max-width: 610px;
  padding: ${({ theme }) => theme.spacing(5, 12)};
  margin: 0 auto;
`
